<template>
    <section class="section">
        <div class="container">
            <div id='scatter-chart' style="width:1200px; height:600px;"></div>
        </div>
    </section>
</template>

<script>

    import VuePlotly from '@statnett/vue-plotly';

    export default {
        name: "ScatterChart",
        components: {
            VuePlotly
        },
        data: function () {
            return {
                data: [{ x: [1, 3], y: [2, 4] }],
                layout: {
                    legend: false,
                    hovermode: 'closest',
                    height: 600,
                    width: 1200,
                    xaxis: {
                        autorange: true,
                        showgrid: false,
                        zeroline: false,
                        showline: true,
                        ticks: '',
                        linecolor: '#bfbfbf',
                    },
                    yaxis: {
                        autorange: true,
                        showgrid: false,
                        zeroline: false,
                        showline: true,
                        ticks: '',
                        linecolor: '#bfbfbf',
                    }
                },
                options: {}
            }
        },
        mounted() {
           Plotly.plot(this.$refs[this.chart.uuid], this.chart.data, this.chart.layout);
        }
    }
</script>

<style scoped>

</style>
